import React from "react";
import greenCheck from "../../assets/images/svg/light-green-check.svg";

// RoadmapCard component to display a roadmap phase with details and an image
const RoadmapCard = ({ value, index }) => {
  return (
    <div className="border-4 relative z-20 bg-body-bg border-dark-purple xl:px-7 lg:px-4 px-7 h-full xl:py-7 lg:py-4 py-7 w-full 2xl:shadow-xlPurpleShadow xl:shadow-lgPurpleShadow shadow-mdPurpleShadow md:rounded-28 rounded-2xl hover:shadow-none transition-all duration-300 ease-in-out hover:translate-x-2 hover:translate-y-2">
      {/* Header section with phase number and date */}
      <div className="flex justify-between items-center">
        <p className="font-normal xl:text-custom-3xl sm:text-2xl text-xl leading-100 text-dark-purple">
          Phase #{index + 1}
        </p>
      </div>
      {/* Image section for the roadmap phase */}
      <div className="xl:pt-6 pt-5">
        <img
          width={364}
          height={324}
          src={value.image}
          alt="roadmap-phase-image"
          className="w-full md:rounded-28 rounded-2xl xl:h-[324px] lg:h-[350px] md:h-[240px] sm:h-[324px] h-[300px] object-cover"
        />
      </div>
      {/* List of items related to the roadmap phase */}
      {value.list.map((subvalue, i) => (
        <div
          key={i}
          className={`flex gap-2.5 items-center ${
            i === 0 ? "xl:pt-7 pt-6" : "sm:pt-[15px] pt-[10px]"
          }`}
        >
          <img
            src={greenCheck}
            alt="light-green-check"
            className="w-4 h-4 sm:w-7 sm:h-7"
          />
          <p className="font-normal 2xl:text-2xl md:text-xl sm:text-lg text-base leading-116 text-dark-purple">
            {subvalue}
          </p>
        </div>
      ))}
    </div>
  );
};

export default RoadmapCard;
